import { ReactElement } from 'react';
import { colors } from '~/styles/colors';

type SlashCircle1IconProps = {
  color?: string;
  size?: string
}

export const SlashCircle1Icon = ({ size = '24', color = colors.icon['white-0'] }: SlashCircle1IconProps): ReactElement => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M4.93 4.93L19.07 19.07M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);
